import { render, staticRenderFns } from "./HandlerClosed.vue?vue&type=template&id=743c1520"
import script from "./HandlerClosed.vue?vue&type=script&lang=js"
export * from "./HandlerClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports